import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import HomeService from "../../../Services/HomeService";
import toast from "react-hot-toast";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function ManagePropertyType() {
    const [propertyTypes, setPropertyTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [propertyTypeID, setPropertyTypeID] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({ propertyType: "" });

    const columns = [
        { name: "S.No.", selector: (row) => row.sln, sortable: true },
        { name: "Property Type", selector: (row) => row.propertyType, sortable: true },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <span title="Edit" onClick={() => handleEdit(row)}>
                        <i
                            className="fa-solid fa-pen-to-square"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "rgb(133, 218, 79)",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                    <span title="Delete" onClick={() => handleDelete(row.id)}>
                        <i
                            className="fa-solid fa-trash-can text-danger"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                </>
            ),
        },
    ];

    const fetchAllPropertyTypes = async () => {
        setLoading(true);
        try {
            const res = await HomeService.getPropertyTypes();
            const arr = res?.data?.map((ele, ind) => ({
                sln: ind + 1,
                propertyType: ele.propertyType,
                id: ele._id,
            }));
            setPropertyTypes(arr);
        } catch (error) {
            console.error("Error fetching property types:", error);
            toast.error("Failed to load property types!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllPropertyTypes();
    }, []);

    const handleEdit = (row) => {
        setIsEdit(true);
        setEditData({ propertyType: row.propertyType });
        setPropertyTypeID(row.id);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete Property Type?",
            text: "Are you sure you want to delete this property type?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            confirmButtonColor: "#d33",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            try {
                await HomeService.deletePropertyType(id);
                Swal.fire("Deleted!", "Property type has been deleted.", "success");
                fetchAllPropertyTypes();
            } catch (error) {
                Swal.fire("Error!", "Failed to delete property type.", "error");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = { propertyType: editData.propertyType };
            if (isEdit) {
                await HomeService.updatePropertyType(propertyTypeID, data);
                toast.success("Property type updated successfully!");
            } else {
                await HomeService.addPropertyType(data);
                toast.success("Property type added successfully!");
            }
            setIsEdit(false);
            setEditData({ propertyType: "" });
            fetchAllPropertyTypes();
        } catch (error) {
            toast.error("Failed to save property type.");
            console.error("Error saving property type:", error);
        }
    };

    return (
        <>
            <div className="main_wrap" style={{ marginTop: "6rem" }}>
                <div className="container-fluid">
                    {isEdit && (
                        <section className="chartBox_area">
                            <h2>Edit Property Type</h2>
                            <hr />
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="propertyTypeName">
                                            Property Type<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="propertyTypeName"
                                            className="form-control"
                                            value={editData.propertyType}
                                            onChange={(e) =>
                                                setEditData({ ...editData, propertyType: e.target.value })
                                            }
                                            placeholder="Enter Property Type Name"
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary mt-3">
                                    Save Changes
                                </button>
                            </form>
                        </section>
                    )}

                    <div className="mt-5">
                        <div style={headLineStyle} className="page-headline">
                            Manage Property Types
                        </div>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={propertyTypes}
                                pagination
                                responsive
                                highlightOnHover
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManagePropertyType;
